import { createSlice } from "@reduxjs/toolkit";
import forgotPasswordApi from "../../../rtk-apis/authentication/forgotPassword";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: "",
};

const forgotPasswordSlice = createSlice({
    name: "forgotPasswordSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(forgotPasswordApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(forgotPasswordApi.fulfilled, (state, { payload }) => {
                console.log('payload', payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(forgotPasswordApi.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default forgotPasswordSlice.reducer;
